const ProductGridSkeleton = () => {
  return <div className="mx-auto animate-pulse px-4 py-6 md:max-w-screen-xl md:px-0 md:py-12" data-sentry-component="ProductGridSkeleton" data-sentry-source-file="ProductGridSkeleton.jsx">
      {/* Header Section */}
      <div className="flex pb-4">
        <div className="me-auto flex items-center space-x-3 rtl:space-x-reverse">
          <div className="h-[36px] w-[90px] bg-gray-200 md:h-[44px]"></div>
        </div>
        <div className="flex space-x-4 rtl:space-x-reverse">
          <div className="hidden space-x-2 sm:flex">
            <div className="size-[44px] rounded bg-gray-200"></div>
            <div className="size-[44px] rounded bg-gray-200"></div>
          </div>
          <div className="flex h-[36px] w-[75px] items-center rounded border border-gray-300 bg-gray-200 px-4 sm:h-[44px] sm:w-[237px]"></div>
        </div>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {[...Array(4)].map((_, index) => <div key={index} className="flex flex-col">
            <div className="mb-4 h-40 bg-gray-300 sm:h-48 md:h-56"></div>
            <div className="mb-2 h-4 bg-gray-300"></div>
            <div className="mb-2 h-4 bg-gray-300"></div>
            <div className="h-6 w-1/2 bg-gray-300"></div>
          </div>)}
      </div>
    </div>;
};
export default ProductGridSkeleton;